var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { apiGetOneClientRfp } from '@/actions/ClientRfpActionsTs';
import { apiUpdateClientRfpViewRequestDisclose, apiUpdateClientRfpViewRequestProposalRequestComment, } from '@/actions/ClientRfpActionsTs/update';
import { wrapNotifyError } from '@/helpers/action';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * データの取得, タブ管理, コンポーネントに渡す値に変更する
 * TODO: viewRequestId -> viewRequestIds に変数名を変えたい（API側も合わせてキー名の修正が必要）
 */
export const useRfpClientOneOfferSubmit = (args) => {
    const { id } = args;
    const dispatch = useDispatch();
    const loadData = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapDispatch(dispatch, apiGetOneClientRfp({
            path: { id },
        }, {}));
    }), [id, dispatch]);
    /**
     * 閲覧申請の提案希望コメントを更新
     */
    const onSubmitProposalRequest = useCallback(({ comment, selectedIds: viewRequestId }) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(dispatch, apiUpdateClientRfpViewRequestProposalRequestComment({
                json: {
                    comment,
                    viewRequestId,
                },
                path: { id },
            }, {}));
            yield loadData();
        }));
    }), [id, loadData, dispatch]);
    /**
     * 閲覧申請の会社名開示の更新
     */
    const onSubmitViewRequest = useCallback((viewRequestId) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(dispatch, apiUpdateClientRfpViewRequestDisclose({
                json: {
                    viewRequestId,
                },
                path: { id },
            }, {}));
            yield loadData();
        }));
    }), [id, loadData, dispatch]);
    return {
        onSubmitProposalRequest,
        onSubmitViewRequest,
    };
};
